module.exports = __webpack_public_path__ + "static/media/snowboarding_1920.56c6b44b.webp";